import { SetStateAction, Dispatch } from 'react'
import { useLocation } from 'react-router-dom'
import { Annotations } from '@pdftron/webviewer'

import { useExtractUrlSearchParams } from '~/lib/extractUrlSearchParams'
import {
    THREE_D_VIEWER_QUERY_PARAM,
    VIEWER_QUERY_PARAM,
} from '~/apps/consumer/pages/Quotes/Admin/AdminQuotingPage/constants'

import ImDfmModal3dViewer from './ImDfmModal3dViewer'
import ImDfmModalPdfViewer from './ImDfmModalPdfViewer'

type ImDfmViewerPanelPropsType = {
    attachmentId: string
    dfmFeedbackId: string | null
    qmrAttachmentAnnotationsUrl?: string
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setImDfmXfdf: Dispatch<SetStateAction<any>>
    setUnsavedImDfmAnnotations: Dispatch<
        SetStateAction<Annotations.Annotation[]>
    >
    unsavedImDfmAnnotations: Annotations.Annotation[]
}

const ImDfmViewerPanel = (props: ImDfmViewerPanelPropsType) => {
    const {
        attachmentId,
        dfmFeedbackId,
        qmrAttachmentAnnotationsUrl,
        setImDfmXfdf,
        setUnsavedImDfmAnnotations,
        unsavedImDfmAnnotations,
    } = props

    const { search } = useLocation()

    const { viewer } = useExtractUrlSearchParams(search, [VIEWER_QUERY_PARAM])

    if (viewer === THREE_D_VIEWER_QUERY_PARAM) {
        return <ImDfmModal3dViewer dfmFeedbackId={dfmFeedbackId} />
    }

    return (
        <ImDfmModalPdfViewer
            attachmentId={attachmentId}
            qmrAttachmentAnnotationsUrl={qmrAttachmentAnnotationsUrl}
            setCurrentPdfData={setImDfmXfdf}
            setUnsavedAnno={setUnsavedImDfmAnnotations}
            unsavedAnno={unsavedImDfmAnnotations}
        />
    )
}

export default ImDfmViewerPanel
